/**
 * Shared React Query staleTime/gcTime tiers.
 *
 * Established to replace ad-hoc inline literals across hooks/*.ts (GitHub #638) so a new
 * hook picks a named tier that reflects its data's real update frequency instead of
 * copy-pasting an arbitrary number.
 */
export const STALE_TIME = {
  /** Fast-changing operational data: accounts, portfolio views, product catalog, signals. */
  FAST: 60 * 1000,
  /** Semi-static reference data: org/user rosters, rarely-changing lookups. */
  STANDARD: 5 * 60 * 1000,
} as const;

export const GC_TIME = {
  /** Matches the global QueryClient default (components/QueryClientProvider.tsx). */
  DEFAULT: 10 * 60 * 1000,
} as const;
